import {
	SecurityParticipationThresholdFormDto,
	SecurityParticipationThresholdShape,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/ParticipationThreshold/participationThreshold.zod.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import {
	DataSecurityWithAllFeaturesAndRanksTct,
	SecurityParticipationThresholdBasis,
} from '@dealstack/shared/lib/generated';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export enum PARTICIPATION_THRESHOLD_FORM_FIELD {
	residueParticipationThresholdBasis = 'residueParticipationThresholdBasis',
	participationThresholdBasisTier = 'participationThresholdBasisTier',
}

export const useParticipationThresholdController = (
	security: DataSecurityWithAllFeaturesAndRanksTct | null,
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) => {
	const defaultValues = useMemo(
		() => ({
			residueParticipationThresholdBasis:
				security?.residueParticipationThresholdBasis ||
				SecurityParticipationThresholdBasis.TOTAL_SOURCES_FOR_ISSUER,
			participationThresholdBasisTier:
				security?.participationThresholdBasisTierId || undefined,
		}),
		[security]
	);

	const participationThresholdForm = useForm<SecurityParticipationThresholdFormDto>({
		mode: 'all',
		resolver: zodResolver(SecurityParticipationThresholdShape(tCapManage)),
		defaultValues,
		shouldFocusError: false,
	});

	const resetForm = () => {
		participationThresholdForm.reset(defaultValues);
	};

	return {
		participationThresholdForm,
		resetForm,
	};
};

export const getSecurityParticipationThresholdBasisTranslation = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	participationThresholdBasis?: SecurityParticipationThresholdBasis
) => {
	if (!participationThresholdBasis) {
		return;
	}

	switch (participationThresholdBasis) {
		case SecurityParticipationThresholdBasis.TOTAL_SOURCES_FOR_ISSUER:
			return tCommonUI('participationThresholdBasis.totalSourcesForIssuer');
		case SecurityParticipationThresholdBasis.TOTAL_PROCEEDS_WITHIN_TIER:
			return tCommonUI('participationThresholdBasis.totalProceedsWithinTier');
		default:
			return participationThresholdBasis;
	}
};
